import { ExerciseParams } from '@pages/TrainingConstructor/types'
import { WorkoutExerciseRequest } from '@entities/training/types/create'

export function buildWorkoutExerciseRequest(params: ExerciseParams): WorkoutExerciseRequest {
	const baseRequest = {
		exercise_id: params.exercise_id,
		order: params.order,
	}

	if (params.type === 'cardio') {
		return {
			...baseRequest,
			duration: params.duration,
			rest_time: params.rest_time,
		}
	}

	return {
		...baseRequest,
		sets: params.sets,
		reps: params.reps,
		duration: params.duration,
		rest_time: params.rest_time,
	}
}
